// 任务容器 mock 数据

export const defaultTasks = [
  {
    task_id: 1,
    task_name: '2024年度骨干人才保留',
    description: '2024年度核心员工离职风险评估与保留计划',
    status: 1,
    enabled_modules: ['employees', 'behaviors', 'config', 'evaluations', 'cases', 'courses', 'contents', 'departure-feedback', 'surveys'],
    start_date: '2024-01-01',
    end_date: '2024-12-31',
    created_at: '2024-01-01'
  },
  {
    task_id: 2,
    task_name: '2025春季专项评估',
    description: '春季重点部门人才流失预警',
    status: 1,
    enabled_modules: ['employees', 'behaviors', 'evaluations'],
    start_date: '2025-03-01',
    end_date: '2025-06-30',
    created_at: '2025-03-01'
  },
  {
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    description: '2026年度核心员工离职风险评估与保留计划',
    status: 1,
    enabled_modules: ['employees', 'behaviors', 'evaluations', 'heatmap', 'survey', 'departure-feedback'],
    start_date: '2026-01-01',
    end_date: '2026-12-31',
    created_at: '2026-01-01'
  }
]
